import React, { useCallback, useEffect, useState } from 'react'
import { Button } from '../../../ui/button'
import { Title, Text2,Text1 } from '../../../ui/text'
import { ChevronLeft } from '../../../../assets/icons'
import theme from '../../../../styled/theme'
import useIsMobile from '../../../../hooks/useIsMobile'
import {
	Content,
	List,
	ListItem,
	RatingBadge,
	RateTextContainer,
	Comments,
	ButtonContainer,
	BackButton,
	ExperienceContent
} from './styled'

const PlatformAppRatingForm = ({ info, handleSubmit, isSmartcard, historyIdHandler, showExperienceTitle }) => {
	const isMobile = useIsMobile()
	const [selectedRatingNumber, setSelectedRatingNumber] = useState(null)
	const [textAreaContent, setTextAreaContent] = useState('')
	const [ratingNumbers, setRatingNumbers] = useState([])
	const [selectedNumberAnswer, setSelectedNumberAnswer] = useState(null)
	const hasRatingValue = !!(selectedRatingNumber || selectedRatingNumber === 0)

	const lastRatingNumber = useCallback(() => {
		const data = info.answerMode
		const lastCharacter = data.charAt(data.length - 1)
		return parseInt(lastCharacter, 10)
	}, [info.answerMode])

	useEffect(() => {
		const length = lastRatingNumber()
		const newNumbers = []
		for (let i = 1; i <= length; i++) {
			newNumbers.push(i)
		}
		setRatingNumbers(newNumbers)
	}, [info.answerMode, lastRatingNumber])

	const handleRatingNumber = number => {
		const answer = info.answers[number - 1]
		setSelectedNumberAnswer(answer)
		setSelectedRatingNumber(number)
	}

	const onFormSubmit = () => {
		handleSubmit({
			questionId: info.id,
			answerMode: info.answerMode,
			answerDescription: selectedRatingNumber,
			answerId: selectedNumberAnswer?.id,
			comment: textAreaContent,
			nextQuestionId: selectedNumberAnswer?.nextQuestionId
		})
	}

	return (
		<Content>
			{!isSmartcard && (
				<BackButton onClick={() => historyIdHandler()}>
					<ChevronLeft
						size={isMobile ? 15 : 12}
						color={isMobile ? theme.colors.text.secondaryText : theme.colors.brand.blueOmint}
					/>
					{!isMobile && <Text2 color={theme.colors.brand.blueOmint}>Volver</Text2>}
				</BackButton>
			)}
			<ExperienceContent>
				<Title
					as="h3"
					size="18px"
					mobileSize="18px"
					margin="0 0 10px 0"
					color={theme.colors.text.primaryText}
				>
					{info.description}
				</Title>
				<div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
				<List>
					{ratingNumbers.map((item, index) => (
						<ListItem
							key={index}
							$ratingNumber={selectedRatingNumber}
							$item={item}
							onClick={() => handleRatingNumber(item)}
						>
							<RatingBadge $ratingNumber={selectedRatingNumber} $item={item}>
								{item}
							</RatingBadge>
						</ListItem>
					))}
				</List>
				</div>
				<RateTextContainer>
					<Text2 size="14px" lineHeight="18px" italic color={theme.colors.text.secondaryText}>
						{`${ratingNumbers[0]} = ${
							isSmartcard ? info.answers[0].description : 'Para nada satisfecho'
						}`}
					</Text2>
					<Text2 size="14px" lineHeight="18px" italic color={theme.colors.text.secondaryText}>
						{`${lastRatingNumber()} = ${
							isSmartcard ? info.answers[info.answers.length - 1].description : 'Muy satisfecho'
						}`}
					</Text2>
				</RateTextContainer>
			</ExperienceContent>
			<ButtonContainer>
				<Button disabled={!hasRatingValue} onClick={onFormSubmit} 
									label={hasRatingValue ? 'Enviar' : 'Siguiente'}
 />
			</ButtonContainer>
		</Content>
	)
}

export default React.memo(PlatformAppRatingForm)
